import { render, staticRenderFns } from "./Stocktaking.vue?vue&type=template&id=25168174&"
import script from "./Stocktaking.vue?vue&type=script&lang=js&"
export * from "./Stocktaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports